import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import { AdminUsersOrderBy, SortDirection } from "src/types/enum";
import SortableTableCell from "./SortableTableCell";
import { STICKY_CHECKBOX, STICKY_NAME } from "./UsersPageUserDetails";

interface Props {
  onRequestSort: (event: React.MouseEvent<unknown>, property: AdminUsersOrderBy) => void;
  order: SortDirection;
  orderBy: AdminUsersOrderBy;
  onSelectCurrentPage: () => void;
  selectCurrentPageChecked: boolean;
  shouldClearSelection: boolean;
  showRecoveryDays?: boolean;
}

const UsersPageTableHead: React.FC<Props> = ({
  onRequestSort,
  order,
  orderBy,
  onSelectCurrentPage,
  selectCurrentPageChecked,
  shouldClearSelection,
  showRecoveryDays,
}: Props) => {
  const createSortHandler = (property: AdminUsersOrderBy) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const orderedByName = orderBy === AdminUsersOrderBy.Name;
  const orderedByEmail = orderBy === AdminUsersOrderBy.Email;
  const orderedByCountry = orderBy === AdminUsersOrderBy.Country;
  const orderedByDate = orderBy === AdminUsersOrderBy.Date;
  const orderedByRecoveryDays = orderBy === AdminUsersOrderBy.RecoveryDays;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox" sx={{ ...STICKY_CHECKBOX, zIndex: 3 }}>
          <Checkbox
            checked={selectCurrentPageChecked}
            indeterminate={shouldClearSelection}
            onChange={onSelectCurrentPage}
          />
        </TableCell>

        <SortableTableCell
          sort={order}
          orderedByProp={orderedByName}
          sortHandler={createSortHandler(AdminUsersOrderBy.Name)}
          sx={{ ...STICKY_NAME, zIndex: 3 }}
        >
          Name
        </SortableTableCell>

        <TableCell>Status</TableCell>

        <TableCell>Community role</TableCell>

        <SortableTableCell
          sort={order}
          orderedByProp={orderedByEmail}
          sortHandler={createSortHandler(AdminUsersOrderBy.Email)}
        >
          E-mail
        </SortableTableCell>

        <SortableTableCell
          sort={order}
          orderedByProp={orderedByCountry}
          sortHandler={createSortHandler(AdminUsersOrderBy.Country)}
        >
          Location
        </SortableTableCell>

        <SortableTableCell
          sort={order}
          orderedByProp={orderedByDate}
          sortHandler={createSortHandler(AdminUsersOrderBy.Date)}
        >
          Joined date
        </SortableTableCell>

        <TableCell>Zone</TableCell>

        <TableCell>Tenure</TableCell>

        <TableCell>Plan</TableCell>

        <TableCell>English</TableCell>

        <TableCell>Fader</TableCell>

        <TableCell>Engagement</TableCell>

        <TableCell>Commitment</TableCell>

        <TableCell align="center">Logins 14d</TableCell>

        <TableCell>Last online</TableCell>

        <TableCell align="center">Events</TableCell>
        {showRecoveryDays ? (
          <SortableTableCell
            sort={order}
            orderedByProp={orderedByRecoveryDays}
            sortHandler={createSortHandler(AdminUsersOrderBy.RecoveryDays)}
          >
            Recovery days
          </SortableTableCell>
        ) : null}

        <TableCell>Last messaged</TableCell>

        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default UsersPageTableHead;
